/** Действия игрока и забежки: ответ сервера, реванш, конец забежки, окна на входе. */
import type { PlayerState } from "@newfungame/contracts";
import { appStore, patch, type AppState } from "./app-state";
import { releaseCoinsShort } from "./coins";
import { closeWindow, openWindow } from "./navigation";
import { progressFlags } from "./selectors";

/** Новое подтверждённое состояние игрока (ответ любой операции API). */
export function setPlayer(player: PlayerState, store = appStore): void {
  // оптимистичные обновления несут прежний `serverTime`: часы сверяем только по ответу сервера
  patch(
    (s) => ({
      player,
      ...(player.serverTime !== s.player?.serverTime ? { clockOffset: player.serverTime - Date.now() } : {}),
      ...releaseCoinsShort({ ...s, player }),
    }),
    store,
  );
}

/**
 * Подкрепление после реванша (MADR 0019): пока сервер ждёт выбора, окно `reviveBoost` открыто. Зовётся из подписки на
 * стор: окно открывается только раз — иначе `openWindow` снова дёргал бы подписку без конца.
 */
export function syncRevivePicks(s: AppState, store = appStore): void {
  if (s.player?.revivePicks && !s.route.windows.some((w) => w.kind === "reviveBoost")) {
    openWindow({ kind: "reviveBoost" }, store);
  }
}

/** Реванш применён: новая забежка с проигранной волны, окно поражения больше не нужно. */
export function runRevived(player: PlayerState, store = appStore): void {
  patch((s) => ({ player, boostOffer: null, runEpoch: s.runEpoch + 1 }), store);
  closeWindow("defeat", store);
}

/** Сервер закрыл забежку: новое состояние, новая забежка, окно «забежка закончилась». */
export function runEnded(player: PlayerState, store = appStore): void {
  patch((s) => ({ player, boostOffer: null, runEpoch: s.runEpoch + 1 }), store);
  closeWindow("boostChoice", store);
  openWindow({ kind: "runEnded" }, store);
}

/**
 * Окна на входе: «с возвращением», если накопился офлайн-доход (серию окно показывает там же, макет 08). Одна лишь
 * несобранная серия окно не открывает — о ней говорит иконка HUD. Кристаллы за неделю лиги показываем отдельным окном. Новичку — ничего: первый экран — бой (практика
 * Sapero: 62 % открытий из рекламы закрывались за 3 с, пока не видели игру).
 */
export function openStartupWindows(store = appStore): void {
  const s = store.get();
  if (!s.player || s.auth.created) return;
  if (progressFlags(s).offlineIncome) openWindow({ kind: "welcomeBack" }, store);
  if ((s.player.league?.unclaimed ?? 0) > 0) openWindow({ kind: "league" }, store);
}
